/*
 * 照片标签限制与预设颜色（一期：1 组团队标签，最多 3 个；个人最多 3 个）
 */
export const TEAM_GROUP_LIMIT = 1 // 免费版最多 1 个标签组
export const TEAM_TAG_LIMIT = 3 // 免费版每组最多 3 个团队标签
export const PERSONAL_TAG_LIMIT = 3 // 免费版最多 3 个个人标签

export const PRESET_COLORS = [
  '#E53935',
  '#FB8C00',
  '#FFB300',
  '#43A047',
  '#00ACC1',
  '#1E88E5',
  '#5E35B1',
  '#8E24AA',
  '#757575',
  '#039BE5'
]
